import TickIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/tick';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { Feature } from '@shared/types/frontend/ubff/hotel-detail-price';

import STYLES from './OfferFeatures.module.scss';

import { isPositiveFeature } from '@hotels-hotel-detail/utils/hotel-offers';

const cls = cssModules(STYLES);

const OfferFeatures = ({ features }: { features: Feature[] }) => (
  <div className={cls('OfferFeatures')}>
    {features.map((feature) => (
      <div
        key={feature.featureType}
        className={cls('OfferFeatures__amenityAndIcon')}
      >
        {isPositiveFeature(feature) ? (
          <TickIcon className={cls('OfferFeatures__amenityIcon')} />
        ) : (
          <div className={cls('OfferFeatures__spot')} />
        )}
        <BpkText
          textStyle={TEXT_STYLES.footnote}
          data-testid="rate_amenity_title"
        >
          {feature.title}
        </BpkText>
      </div>
    ))}
  </div>
);

export default OfferFeatures;
